import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCoins, FaArrowLeft, FaShoppingCart } from "react-icons/fa";
import Tooltip from "./Tooltip";
import "./BuyCredits.css";

const BuyCredits = () => {
  const navigate = useNavigate();

  const creditOptions = [
    { amount: 150, price: 9 },
    { amount: 350, price: 19 },
    { amount: 1000, price: 49 },
  ];

  const handlePurchase = (amount, price) => {
    alert(`Proceeding to purchase ${amount} credits for $${price}`);
    navigate(`/checkout?amount=${amount}&price=${price}`);
  };

  return (
    <div className="buy-credits-container">
      <h1 className="buy-credits-title">Buy Credits <Tooltip textKey="credits"  /></h1>
      <p className="buy-credits-subtitle">Select a credit package:</p>

      <div className="credit-options">
      
        {creditOptions.map((option) => (
          <div key={option.amount} className="credit-option">
            <div className="buy-credits-details">
                <FaCoins className="credit-icon" />
            <h2 className="credit-amount-title">{option.amount} Credits</h2>
             </div>
             <div className="credit-price">
               <span className="price-amount">${option.price}</span>
               <span className="price-per-credit">${(option.price / option.amount).toFixed(3)} per credit</span>
             </div>
            <button
              className="buy-button"
              onClick={() => handlePurchase(option.amount, option.price)}
            >
              <FaShoppingCart className="button-icon" /> Buy Now
            </button>
          </div>
        ))}
      </div>

      <button className="back-button" onClick={() => navigate(-1)}>
        <FaArrowLeft className="button-icon" /> Back
      </button>
    </div>
  );
};

export default BuyCredits;